<template>
    <v-container>
        <v-row class="justify-center">
            <v-col cols="12" md="8" lg="6" xl="6">
                <v-img
                    :src="require('@/assets/img/education/waterloo.png')"
                    class="my-3"
                    contain
                />
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="12" lg="4" xl="4">
                <div class="education-text text-center">
                    <div class="education-title larger-text-sizing">University of Waterloo</div>
                    <div class="education-sub-heading standard-text-sizing my-1">Bachelor of Computing and Financial Management</div>
                    <p>September 2012 - June 2017</p>
                </div>
            </v-col>
            <v-col cols="12" lg="4" xl="4">
                <div class="education-text text-center">
                    <div class="education-title larger-text-sizing">Awards and Achievements</div>
                    <div>
                        <span v-for="award in awards" :key="award.name">
                            <div class="education-sub-heading standard-text-sizing my-1">{{ award.name }}</div>
                            <div class="standard-text-sizing" v-for="item in award.items" :key="item.name">{{ item.name }}, {{ item.year }}</div>
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Education',

    data: () => ({
        awards : [
            {
                name: 'University of Waterloo',
                items: [
                            {
                                name: `Graduated with Distinction - Dean's Honour List`,
                                year: '2017'
                            },      
                            {
                                name: `Dean's Honour List`,
                                year: '2013 - 2017'
                            },
                            {
                                name: `Retirees' Scholarship/Award`,
                                year: '2013'
                            },
                            {
                                name: `Merit Entrance Scholarship`,
                                year: '2012'
                            }
                    ],
                },
            {
                name: 'Ontario',
                items: [
                            {
                                name: 'Scholar Award',
                                year: '2012'
                            }
                    ]
            }
        ]
    }),
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';

.education-text {
    letter-spacing: 0.5px;

    .education-title {
        color: $educationTitle;
        font-weight: bold;
    }
    
    .education-sub-heading {
        color: $educationTitle;
    }
}
</style>

